import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "constants/api_urls";
import axios from "axios";
import { getUserToken } from "utils/functions/userToken";

export const validateHeadline = async (headlineText) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-headline/`,
            {
               assetContent: headlineText
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validatePrimaryText = async (primaryText) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-primary-text/`,
            {
               assetContent: primaryText
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateWebSiteURL = async (websiteURL) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-web-site-url/`,
            {
               url: websiteURL
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateCallToAction = async (callToActionText) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-call-to-action/`,
            {
               assetContent: callToActionText
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateFeedLinkDescription = async (feedLinkDescription) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-feed-link-description/`,
            {
               assetContent: feedLinkDescription
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateDeepLink = async (deepLink) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-deep-link-to-website/`,
            {
               url: deepLink
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateMarketingImage = async (marketingImage) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-marketing-image/`,
            {
               url: marketingImage
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateLogoImage = async (logoImage) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-logo-image/`,
            {
               url: logoImage
            }, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};

export const validateAdsCreative = async (adsCreative) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/campaign-validator/ads-creative/validate-ads-creative/`,
            adsCreative, {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.[0]?.errorMessage || "Validation failed";
        return { success: false, error: errorMessage };
    }
};